
export default function TargetAudience() {
  const handleCTAClick = () => {
    const ctaSection = document.getElementById('contact');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 md:py-40 px-6 bg-gray-50">
      <div className="max-w-3xl mx-auto text-center">
        <ul className="space-y-3 md:space-y-6 mb-12 md:mb-20">
          <li className="text-sm md:text-2xl font-light text-gray-700 inline-block w-4/5 md:w-auto py-2 md:py-0">・ダンス未経験の方</li>
          <li className="text-sm md:text-2xl font-light text-gray-700 inline-block w-4/5 md:w-auto py-2 md:py-0">・かっこよく動きたい方</li>
          <li className="text-sm md:text-2xl font-light text-gray-700 inline-block w-4/5 md:w-auto py-2 md:py-0">・身体を変えたい方</li>
        </ul>
        
        <button
          onClick={handleCTAClick}
          className="inline-block w-auto px-8 py-3 md:px-16 md:py-5 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-sm md:text-2xl font-medium rounded-full hover:from-orange-600 hover:to-orange-700 transition-all cursor-pointer whitespace-nowrap shadow-md hover:shadow-lg"
        >
          先行の案内を受け取る
        </button>
      </div>
    </section>
  );
}
